(function() {
	var rellax = new Rellax(".simple-parallax", {
		center: true,
	});
})();



// WEBPACK FOOTER //
// ./js/components/parallax.js